import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Advantages from '../pages/advantages/page';
import Products from '../pages/products/page';
import CexPage from '../pages/products/cex/page';
import RwaPage from '../pages/products/rwa/page';
import WalletPage from '../pages/products/wallet/page';
import DefiPage from '../pages/products/defi/page';
import MiningPage from '../pages/products/mining/page';
import NewsPage from '../pages/news/page';
import NewsDetailPage from '../pages/news/detail/page';
import ContactPage from '../pages/contact/page';
import ServicesPage from '../pages/services/page';
import ServiceDetailPage from '../pages/services/detail/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/advantages',
    element: <Advantages />,
  },
  {
    path: '/products',
    element: <Products />,
  },
  {
    path: '/products/cex',
    element: <CexPage />,
  },
  {
    path: '/products/rwa',
    element: <RwaPage />,
  },
  {
    path: '/products/wallet',
    element: <WalletPage />,
  },
  {
    path: '/products/defi',
    element: <DefiPage />,
  },
  {
    path: '/products/staking',
    element: <Navigate to="/products/defi" replace />,
  },
  {
    path: '/products/mining',
    element: <MiningPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/:slug',
    element: <ServiceDetailPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/news/:id',
    element: <NewsDetailPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
